'use client';

import { useInView } from '@/hooks/use-in-view';
import { cn } from '@/lib/cn';

type WordRevealProps = {
  text: string;
  className?: string;
  step?: number;
};

/** Fades a sentence in word by word once it enters the viewport. */
export function WordReveal({ text, className, step = 26 }: WordRevealProps) {
  const { ref, inView } = useInView<HTMLParagraphElement>();

  return (
    <p ref={ref} className={className}>
      {text.split(' ').map((word, index) => (
        <span
          key={`${word}-${index}`}
          data-shown={inView || undefined}
          style={{ transitionDelay: `${120 + index * step}ms` }}
          className={cn(
            'mr-[0.26em] inline-block opacity-15 transition-opacity duration-700 ease-out',
            'data-shown:opacity-100 motion-reduce:opacity-100',
          )}
        >
          {word}
        </span>
      ))}
    </p>
  );
}
